import React from 'react'
import {useParams} from "react-router-dom";
import { Layout } from 'antd';
import { PageHeader } from 'antd';
import myHeader from '../../Components/CourseHeader/Header'
import MainContent from '../../Components/CourseMainContent/MainContent';
import logo from '../../Assests/assets/images/layer-1.png';
const { Header, Footer, Content } = Layout;
const CoursePage = (props)=>{

  console.log(props.match)
  const { id } = useParams();
  console.log(id);
  return (
    <Layout>
      <Header className="site-page-header">
        <p class='header-img-container'>
          <img src={logo} class='header-img'/> 
        </p>

        {/*
    <PageHeader
      className="site-page-header"
      backIcon="false"
      title= <img src={logo} class='header-img'/> 
    />
    */}
      </Header>
      <Content class="site-page-content">
        <MainContent/>
      </Content>
      <Footer className='site-page-footer'></Footer>
    </Layout>
  )
}
export default CoursePage; 
